// Contracts — javelin study config (the participant-intake consent
// screen's sponsor block + Informed-Consent reader text). Worker side:
// apps/api/src/javelin/study.ts getStudyConfig(), reading the singleton
// javelin_study_config row (migration 0024). Client side: apps/internal
// intake slice (features/intake/service.ts). The values are
// study-confidential and live only in D1 — committed source carries a
// generic fallback, so this read may legitimately return empty strings
// on a contour whose row hasn't been seeded.
import { z } from 'zod';

export const JavIcfSectionSchema = z.looseObject({
  h: z.string().default(''),
  p: z.string().default(''),
});

export const JavIcfSectionsSchema = z.looseObject({
  en: z.array(JavIcfSectionSchema).default([]),
  ru: z.array(JavIcfSectionSchema).default([]),
  es: z.array(JavIcfSectionSchema).default([]),
});

export const JavStudyConfigResSchema = z.looseObject({
  study_name: z.string().default(''),
  sponsor_name: z.string().default(''),
  organizer: z.string().default(''),
  organizer_note: z.string().default(''),
  compensation: z.string().default(''),
  study_lead_email: z.string().default(''),
  icf_doc_url: z.string().default(''),
  icf_sections: JavIcfSectionsSchema.default({ en: [], ru: [], es: [] }),
});

export type JavIcfSection = z.infer<typeof JavIcfSectionSchema>;
export type JavStudyConfigRes = z.infer<typeof JavStudyConfigResSchema>;
